module.exports = __webpack_public_path__ + "static/img/beijinhoulang.d08ba44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/beijinhoulang.jpg
// module id = bWw7
// module chunks = 46